import { API_PREFIX } from '../../../shared/constants';
import { createRestClient, assertStatusCode } from '../../shared/rest';
import { Customer } from '@pegasus/types/auth';

export interface Response {
    results: Customer;
}

export const fetchCustomer = (): Promise<Response> => {
    const client = createRestClient(API_PREFIX, false);

    return client
        .get(`/customer/me`)
        .then(assertStatusCode([200]))
        .then(response => response.json());
};
